(function () {
  function initializeSlider(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var track = root.querySelector('.hero-slider__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slider__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slider__dot'));
    var prevBtn = root.querySelector('.hero-slider__arrow--prev');
    var nextBtn = root.querySelector('.hero-slider__arrow--next');
    var total = slides.length;
    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;
    var touchStartX = 0;
    var touchStartY = 0;

    if (!track || !total) return;
    root.dataset.initialized = 'true';

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', String(i !== current));
      });
      dots.forEach(function (dot, i) {
        var isActive = i === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stopAutoplay() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || total <= 1) return;
      timer = setInterval(next, autoplaySpeed);
    }

    nextBtn?.addEventListener('click', function () {
      next();
      startAutoplay();
    });

    prevBtn?.addEventListener('click', function () {
      prev();
      startAutoplay();
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dotIndex, 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    root.addEventListener('touchstart', function (event) {
      var touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      stopAutoplay();
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      var touch = event.changedTouches[0];
      var distanceX = touchStartX - touch.clientX;
      var distanceY = touchStartY - touch.clientY;

      if (Math.abs(distanceX) > 40 && Math.abs(distanceX) > Math.abs(distanceY)) {
        distanceX > 0 ? next() : prev();
      }
      startAutoplay();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stopAutoplay() : startAutoplay();
    });

    goTo(0);
    startAutoplay();
  }

  function initializeAllSliders(scope) {
    scope = scope || document;
    if (scope.matches?.('[data-moments-slider]')) initializeSlider(scope);
    scope.querySelectorAll?.('[data-moments-slider]').forEach(initializeSlider);
  }

  initializeAllSliders(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAllSliders(event.target);
  });
})();
